import { render, staticRenderFns } from "./QueenyTestPage.vue?vue&type=template&id=0aeee816&scoped=true&"
import script from "./QueenyTestPage.vue?vue&type=script&lang=ts&"
export * from "./QueenyTestPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeee816",
  null
  
)

export default component.exports